import { Component, Input } from '@angular/core';
import { AggregatedJobData } from '@shared';

@Component({
  selector: 'mojo-pipeline-total-matches-numbers',
  styleUrls: ['./pipeline-total-matches-numbers.component.scss'],
  templateUrl: './pipeline-total-matches-numbers.component.html',
})
export class PipelineTotalMatchesNumbersComponent {
  @Input() aggregatedJobData: AggregatedJobData;
}
